<template>
  <app-view>
    <div class="nav">
      <div>
        <a href="javascript:;" v-for="(item,i) in bible" :key="i" :class="{on:selected===i}"
           @click="onSelected(i)">{{item.name}}</a>
      </div>
    </div>
    <div class="details" v-if="selected===2">
      <a href="javascript:;" v-for="(d,i) in contents" :key="i" @click="onGo(d)">
        <div>{{d.name}}</div>
      </a>
    </div>
    <template v-else>
      <template v-for="(item,index) in contents">
        <div class="option">{{item.name}}</div>
        <div class="details">
          <a href="javascript:;" v-for="(d,i) in item.child" :key="i" @click="onGo(d)">
            <div>{{d.letter}}</div>
            <div>{{d.name}}</div>
          </a>
        </div>
      </template>
    </template>
  </app-view>
</template>
<script>
  import AppView from '../components/AppView.vue'

  export default {
    components: {AppView},
    data () {
      return {
        selected: 0
      }
    },
    computed: {
      bible () {
        return this.$service.category.bible
      },
      contents () {
        return this.bible[this.selected] && this.bible[this.selected].child
      }
    },
    mounted () {
      this.$service.category.loadBible()
    },
    methods: {
      onSelected (i) {
        this.selected = i
      },
      onGo (item) {
        this.$router.push({
          name: 'bookshelf',
          query: {
            bid: item.bible_id,
            name: item.name
          }
        })
      }
    }
  }
</script>
<style scoped lang='scss'>
  .view {
    padding-top: 48px;
  }

  .nav {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    padding: 6px 14px;
    background-color: #f7f7f7;
    > div {
      display: flex;
      align-items: center;
      border: 1px solid #f15e5f;
      border-radius: 6px;
      background-color: white;
      text-align: center;
      overflow: hidden;
      > a {
        flex: 1;
        height: 36px;
        line-height: 36px;
        &:nth-child(2) {
          border-left: 1px solid #f15e5f;
          border-right: 1px solid #f15e5f;
        }
        &.on {
          color: white;
          background-color: #f15e5f;
        }
      }
    }
  }

  .option {
    margin: 3px 14px 10px;
    padding-left: 10px;
    line-height: 32px;
    background-color: #eeeeee;
    border-radius: 6px;
  }

  .details {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-left: 14px;
    > a {
      width: 62px;
      height: 63px;
      background-color: white;
      border-radius: 6px;
      margin-bottom: 8px;
      margin-right: 5px;
      padding-top: 10px;
      > div {
        text-align: center;
        &:first-child {
          font-size: 17px;
          margin-bottom: 3px;
          padding: 0 10px;
        }
        &:nth-child(2) {
          font-size: 11px;
          color: #999999;
          line-height: 1.2;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// index.vue?88c7f6c6